        @file:Suppress("unused")
        package com.hyperether.resources
        
        object StringsDe {
            val strings: Map<String, String> = mapOf(
"app_name" to "GoodJob",
"welcome" to "Willkommen bei GoodJob",
"onboarding_description1" to "Deine Plattform für die Verwaltung von Aufgaben, die Überwachung des Fortschritts und die Organisation von allem.",
"onboarding_description2" to "Erstelle Aufgaben, weise sie Teammitgliedern zu und behalte ihren Status im Auge. Alles an einem Ort.",
"powerful_tools" to "Leistungsstarke Werkzeuge",
"next" to "Weiter",
"back" to "Zurück",
"skip" to "Überspringen",
"sign_in" to "Anmelden",
"join_good_job" to "Mach mit bei GoodJob!",
"sign_in_good_job" to "Bei GoodJob anmelden",
"start_organizing" to "Fang heute an, dein Team zu organisieren",
"access_the_platform" to "Zugriff auf die Plattform, wo Vorgesetzte Aufgaben verteilen und Mitarbeiter sie nachverfolgen und erledigen – alles an einem Ort!",
"full_name" to "Vollständiger Name",
"your_full_name" to "Dein vollständiger Name",
"email_address" to "E-Mail-Adresse",
"email_address_mandatory" to "E-Mail-Adresse *",
"your_email_address" to "Deine E-Mail-Adresse",
"password" to "Passwort",
"repeat_password" to "Passwort wiederholen",
"your_password" to "Dein Passwort",
"register_with" to "oder",
"register" to "Registrieren",
"welcome_back" to "Willkommen zurück!",
"forgot_password" to "Passwort vergessen?",
"sign_in_with" to "oder",
"manage_employees" to "Verwalte deine Mitarbeiter, Aufgaben und Zeitplan ohne Anstrengung",
"hello" to "Hallo!",
"locations_agenda" to "Standorte auf deiner Agenda",
"locations_agenda_text" to "Schau dir die Jobs und Standorte auf der Karte an für einen klaren Überblick über die zugewiesenen Aufgaben.",
"join_us" to "Mach heute mit und leg los!",
"effortless_efficiency" to "EINFACHE EFFIZIENZ",
"transform" to "Verändere, wie dein Team mit GoodJob arbeitet",
"optimize_your" to "Optimiere deine Jobverwaltung mit einer Lösung, die für Effizienz, Zusammenarbeit und Skalierbarkeit entwickelt wurde.",
"enter_your_email" to "Gib deine E-Mail-Adresse ein",
"continue_with_google" to "Weiter mit Google",
"continue_with_microsoft" to "Weiter mit Microsoft",
"continue_with_fb" to "Weiter mit Facebook",
"continue_with_apple" to "Weiter mit Apple",
"choose_the_right_plan" to "Wähle den richtigen Plan für dich",
"free" to "Kostenlos",
"month" to "/Monat",
"users" to "Benutzer",
"fast_track" to "Schnellspur-Support innerhalb von 8 Stunden",
"day_free_trial" to "7-Tage kostenlose Testversion. Jederzeit kündbar.",
"built_for" to "Entwickelt für aktive Teams, mit Funktionen, die die Produktivität ohne Anstrengung steigern.",
"ready_for" to "Bereit für einen weiteren produktiven Tag?",
"already_have_an_account" to "Hast du schon ein Konto?",
"need_an_account" to "Brauchst du ein Konto?",
"create_one" to "Erstellen",
"most_popular" to "AM BELIEBTESTEN",
"all_rights_reserved" to "2024 Mycomp IT-Services GmbH - www.mycomp.ch. Alle Rechte vorbehalten.",
"privacy_policy" to "Datenschutzrichtlinie",
"terms_of_service" to "Nutzungsbedingungen",
"free_100" to "Es ist 100% kostenlos und wir schicken dir nie mehr als eine E-Mail pro Monat",
"its" to "Es ist",
"free_hundred" to "100% gratis",
"and_we_will" to "und wir schicken dir nie mehr als eine E-Mail pro Monat",
"pricing" to "PREISGESTALTUNG",
"transparent_flexible" to "Transparente, flexible Preisgestaltung für jede Teamgröße",
"whether" to "Egal ob du ein kleines Team managst oder ein größeres Unternehmen leitest, GoodJob bietet flexible Pläne, die mit deinem Geschäft wachsen.",
"unlimited_storage" to "Unbegrenzter Speicherplatz",
"publish_key" to "pk_test_51QKL8eJYnILGHOmxNRipLB7zsIeMYqbPeLVtm17ZtZSrCCaTDG9yyByNosu6fhupi59rDbogvg1cbvyxM7e92KjH00eMjqJqTp",
"register_msg" to "Effiziente Lösungen für Mitarbeiter- und Aufgabenverwaltung",
"subscribe" to "Abonnieren",
"choose_plan" to "Plan wählen",
"contact_us" to "Kontaktieren Sie uns",
"login_register" to "Anmelden/Registrieren",
"user" to "Benutzer",
"support" to "Support innerhalb von 8 Stunden",
"priority_support" to "Prioritäts-Support innerhalb von 8 Stunden",
"fast_track_support" to "Schnellspur-Support innerhalb von 8 Stunden",
"dedicated_support" to "Persönlicher Support innerhalb von 8 Stunden",
"freebie_plan_description" to "Unterstütze dein Team mit allem Nötigen für einen guten Start.",
"high_five_plan_description" to "Perfekt für wachsende Teams, konzipiert zum grenzenlosen Skalieren.",
"fly_high_plan_description" to "Entwickelt für aktive Teams, mit Funktionen, die die Produktivität ohne Anstrengung steigern.",
"galactic_plan_description" to "Maßgeschneidert für Unternehmen, bietet unübertroffene Kraft und Präzision für dein Team.",
"dashboard" to "Dashboard",
"no_tasks_created" to "Keine Aufgaben erstellt",
"no_tasks_assigned" to "Du hast noch keine Aufgaben zugewiesen. Fang an mit einer neuen Aufgabe, um dein Team voranzubringen.",
"check_soon" to "Du hast momentan keine Aufgaben. Schau bald wieder vorbei oder nimm Kontakt mit deinem Vorgesetzten auf.",
"today_schedule" to "Heutiger Zeitplan",
"jobs_overview" to "Jobs-Überblick",
"jobs_list" to "Jobliste",
"filter" to "Filter",
"personal_details" to "Persönliche Angaben",
"choose_the_plan" to "Hallo! Wähle den Plan, der zu dir passt!",
"from_small_teams" to "Von kleinen Teams bis zu großen Unternehmen, wir haben einen Plan, der mit dir wächst. Wähle den, der zu deinen Zielen passt und fang an, deinen Workflow zu optimieren.",
"select_your_workspace" to "Wähle deinen Arbeitsbereich",
"select_role" to "Rolle wählen",
"choose_your_workspace" to "Wähle einen Arbeitsbereich, um auf dein Dashboard zuzugreifen",
"access_dashboard" to "Zugriff auf Dashboard",
"create_workspace" to "Neuen Arbeitsbereich erstellen",
"new_workspace" to "Neuer Arbeitsbereich",
"add_new_workspace" to "Neuen Arbeitsbereich hinzufügen",
"role" to "Rolle",
"role_mandatory" to "Rolle *",
"last_accessed" to "Letzter Zugriff:",
"plan" to "Plan:",
"set_up_workspace" to "Richte deinen Arbeitsbereich ein und fang an mit deinem Dashboard.",
"workspace_name" to "Arbeitsbereich Name",
"enter_workspace_name" to "Gib den Namen deines Arbeitsbereichs ein",
"create" to "Erstellen",
"choose_category" to "Wähle die Kategorie",
"already_have_workspace" to "Hast du schon einen Arbeitsbereich?",
"click_here" to "Klick hier, um ihn zu wählen",
"today" to "Heute",
"add_new" to "Neu",
"add_new_job" to "Neuen Job hinzufügen",
"create_new_task" to "Plane und weise eine neue Aufgabe deinem Team zu, mit Zeitplänen und Details.",
"create_new_employee" to "Erweitere dein Team mit einem neuen Mitarbeiter, mit Rolle und Fähigkeiten.",
"add_new_employee" to "Neuen Benutzer hinzufügen",
"no_hours_available" to "Keine Stunden verfügbar",
"confirm" to "Bestätigen",
"users_title" to "Benutzer",
"search_users" to "Benutzer suchen",
"assigned" to "Zugewiesen",
"no_working_hours_available" to "Keine Arbeitsstunden verfügbar",
"update_employee" to "Mitarbeiter aktualisieren",
"enter_surname" to "Gib Nachname und Vorname ein",
"phone" to "Telefon",
"enter_employee_email" to "Gib die E-Mail-Adresse des Mitarbeiters ein",
"zip" to "PLZ",
"enter_zip" to "Gib die Postleitzahl ein",
"enter_street" to "Gib Straßenname und Hausnummer ein",
"address" to "Adresse",
"address_mandatory" to "Adresse *",
"status" to "Status",
"status_mandatory" to "Status *",
"active" to "Aktiv",
"inactive" to "Inaktiv",
"skills" to "Fähigkeiten",
"skill" to "Fähigkeit",
"select_skill" to "Fähigkeit wählen oder erstellen",
"team" to "Team",
"select_team" to "Team wählen oder erstellen",
"select_industry" to "Branche wählen oder erstellen",
"add" to "Hinzufügen",
"update" to "Aktualisieren",
"update_job" to "Job aktualisieren",
"delete_contact" to "Kontakt löschen",
"tap_to_upload_photo" to "Tippe zum Foto hochladen",
"workspace_type" to "Arbeitsbereich-Typ",
"employees" to "Benutzer",
"save_new_site" to "Neuen Standort speichern",
"about_site" to "Über den Standort",
"all" to "Alle",
"teams" to "Teams",
"edit" to "Bearbeiten",
"total" to "Total",
"cancel" to "Abbrechen",
"delete" to "Löschen",
"export_list" to "Liste exportieren",
"import_list" to "Liste importieren",
"about_job" to "Über den Job",
"about_this_contact" to "Über diesen Kontakt",
"job_title" to "Jobtitel",
"job_title_mandatory" to "Jobtitel *",
"title" to "Titel",
"time" to "Zeit",
"enter_job_title" to "Gib den Jobtitel ein",
"save_changes" to "Änderungen speichern",
"job_status" to "Jobstatus",
"job_status_draft" to "Entwurf",
"job_status_open" to "Offen",
"job_status_in_progress" to "In Bearbeitung",
"job_status_on_hold" to "Auf Halt",
"job_status_pending_approval" to "Warte auf Genehmigung",
"job_status_completed" to "Abgeschlossen",
"job_status_cancelled" to "Abgebrochen",
"select_job_status" to "Jobstatus wählen",
"assign_employee" to "Zuweisen",
"select_employee" to "Mitarbeiter wählen",
"select_team_or_user" to "Team oder Benutzer wählen",
"date" to "Datum",
"start_date" to "Startdatum",
"start_at" to "Start um",
"end_at" to "Ende um",
"repeat" to "Wiederholen",
"never" to "Nie",
"due_date" to "Fälligkeitsdatum",
"job_duration" to "Jobdauer",
"add_steps" to "Aufgabe hinzufügen",
"step_title" to "Aufgabentitel",
"enter_step_title" to "Gib den Aufgabentitel ein",
"step_description" to "Aufgabenbeschreibung",
"describe_the_process" to "Beschreibe den Prozess",
"estimated_duration" to "Geschätzte Dauer",
"continue_with_next_step" to "Mit nächster Aufgabe fortfahren",
"add_step" to "Aufgabe hinzufügen",
"add_notes" to "Notizen hinzufügen",
"files" to "Dateien",
"provide_information" to "Gib weitere Informationen an",
"upload_documents" to "Dokumente und Bilder hochladen",
"max_size" to "Maximale Dateigröße: 10 MB",
"only_support" to "Nur .jpg, .png und .pdf Dateien werden unterstützt",
"enter_time" to "Zeit eingeben",
"hour" to "Stunde",
"minute" to "Minute",
"step" to "Aufgabe",
"every_day" to "Jeden Tag",
"every_week" to "Jede Woche",
"every_2_weeks" to "Alle 2 Wochen",
"every_month" to "Jeden Monat",
"custom" to "Individuell",
"repeat_daily_weekday" to "Jeden Wochentag",
"repeat_daily_workday" to "Jeden Arbeitstag",
"repeat_interval" to "Intervall",
"ok" to "OK",
"jobs" to "Jobs",
"job" to "Job",
"scheduler" to "Planer",
"contacts" to "Kontakt",
"contact_deteils" to "Kontaktdetails",
"contact" to "Kontakt",
"places" to "Standorte",
"settings" to "Einstellungen",
"logout" to "Abmelden",
"job_details" to "Jobdetails",
"about_contact" to "Über Kontakt",
"delete_site" to "Standort löschen",
"details" to "Details",
"steps" to "Aufgaben",
"site" to "Standort",
"add_job" to "Job hinzufügen",
"site_contact_person" to "Standort & Kontaktperson",
"company" to "Firma",
"contact_name" to "Kontaktname",
"contact_name_mandatory" to "Kontaktname *",
"contact_name_and_type" to "Kontaktname & Typ",
"contact_site" to "Standort wählen",
"full_name_contact_person" to "Vollständiger Name der Kontaktperson",
"add_new_contact" to "Neuen Kontakt hinzufügen",
"contact_type" to "Kontakttyp",
"industry" to "Branche",
"enter_contact_name" to "Gib den Kontaktname ein",
"add_client" to "Füge Kunden- oder Firmenkontaktinformationen für die Aufgabenverteilung hinzu.",
"expand_your_team" to "Erweitere dein Team mit einem neuen Mitarbeiter, mit Rolle und Fähigkeiten.",
"plan_and_assign" to "Plane und weise eine neue Aufgabe deinem Team zu, mit Zeitplänen und Details.",
"use_contact_name" to "Zusätzliche Kontaktperson hinzufügen",
"enter_email_address" to "Gib die E-Mail-Adresse ein",
"enter_building_number" to "Gib Straßenname und Hausnummer ein",
"contact_person" to "Kontaktperson",
"employee_details" to "Benutzerdetails",
"enter_full_name" to "Gib den vollständigen Namen ein",
"start_typing_address" to "Fang an, die Adresse einzugeben, um Vorschläge zu sehen...",
"email" to "E-Mail",
"email_capital" to "E-Mail",
"choose_team" to "Wähle ein Team",
"add_team" to "Team hinzufügen",
"create_your_first_team" to "Erstelle dein erstes Team",
"start_by_adding" to "Du hast noch keine Teams erstellt. Fang an mit einem, und es wird hier erscheinen. Einmal erstellt, kannst du Mitarbeiter zum Team hinzufügen.",
"no_tasks_yet" to "Noch keine Aufgaben",
"no_tasks_text" to "Noch keine Aufgaben für diesen Job hinzugefügt. Du kannst den Job aktualisieren, um Aufgaben hinzuzufügen.",
"no_tasks_text_employee" to "Für diesen Auftrag wurden noch keine Aufgaben hinzugefügt. Aufgaben werden angezeigt, sobald sie erstellt sind.",
"work_schedule" to "Arbeitsplan",
"set_weekly_hours" to "Wochenzeiten festlegen",
"upcoming_leaves" to "Kommende Urlaub",
"upcoming_tasks" to "Kommende Aufgabe",
"upcoming_jobs" to "Kommende Jobs",
"select_dates" to "Datum wählen",
"no_employees_added" to "Keine Mitarbeiter hinzugefügt",
"no_contacts_available" to "Kein Kontakt verfügbar",
"add_a_contact" to "Füge einen Kontakt hinzu, um Jobs zu verwalten und Kontaktdetails an einem Ort zu haben.",
"add_employees" to "Dieses Team beginnt hier. Füge Mitarbeiter hinzu, um Jobs zuzuweisen und die Arbeit organisiert zu haben.",
"upload_profile_picture" to "Profilbild hochladen",
"error" to "Fehler",
"error_message" to "Es ist ein Fehler aufgetreten, bitte versuche es nochmal",
"daily_activities" to "Tägliche Aktivitäten",
"contact_information" to "Kontaktinformationen",
"employment_details" to "Anstellungsdetails",
"leave_details" to "Urlaubsdetails",
"all_employees" to "Alle Benutzer",
"team_added" to "Team erfolgreich hinzugefügt",
"team_deleted" to "Team erfolgreich gelöscht",
"unselect_all" to "Alle abwählen",
"search" to "Suchen",
"name" to "Name",
"phone_number" to "Telefonnummer",
"city" to "Stadt",
"clear" to "Löschen",
"clear_all" to "Alles löschen",
"completion_report" to "Abschlussbericht",
"task_completion_report" to "Aufgabenabschlussbericht",
"approve" to "Genehmigen und als abgeschlossen markieren",
"reject" to "Ablehnen und zur Überprüfung zurückschicken",
"monthly" to "Monatlich",
"yearly" to "Jährlich - 20%",
"sort_by" to "Sortieren nach:",
"workspace_settings" to "Arbeitsbereich-Einstellungen",
"roles_permission" to "Rolle & Berechtigungen",
"subscription" to "Abonnement",
"profile_settings" to "Profileinstellungen",
"log_out" to "Abmelden",
"working_hours" to "Arbeitsstunden",
"monday" to "Montag",
"tuesday" to "Dienstag",
"wednesday" to "Mittwoch",
"thursday" to "Donnerstag",
"friday" to "Freitag",
"saturday" to "Samstag",
"sunday" to "Sonntag",
"zip_employee" to "PLZ",
"country" to "Land",
"location_details" to "Standortdetails",
"location" to "Standort",
"schedule" to "Zeitplan",
"no_worries" to "Keine Angst, wir helfen dir!",
"send_reset_link" to "Link zum Zurücksetzen schicken",
"forgot_your_password" to "Hast du dein Passwort vergessen?",
"confirm_registration" to "Registrierung bestätigen",
"reset_link_sent" to "Link zum Zurücksetzen verschickt!",
"set_new_password" to "Setze dein neues Passwort",
"new_password" to "Neues Passwort",
"confirm_password" to "Passwort bestätigen",
"save_password" to "Passwort speichern",
"success" to "Erfolg",
"about" to "Über",
"sites" to "Standorte",
"update_contact" to "Kontakt aktualisieren",
"files_notes" to "Dateien & Notizen",
"password_updated" to "Passwort aktualisiert! Du kannst dich jetzt mit deinen neuen Anmeldedaten anmelden.",
"create_strong_password" to "Erstelle ein starkes Passwort, um dein Konto zu sichern.",
"employee_added_successfully" to "Benutzer erfolgreich hinzugefügt",
"employee_updated_successfully" to "Benutzer erfolgreich aktualisiert",
"contact_added_successfully" to "Kontakt erfolgreich hinzugefügt",
"contact_updated_successfully" to "Kontakt erfolgreich aktualisiert",
"job_added_successfully" to "Job erfolgreich hinzugefügt",
"job_updated_successfully" to "Job erfolgreich aktualisiert",
"date_error" to "Vergangene Daten können nicht gewählt werden.",
"add_new_site" to "Neuen Standort hinzufügen",
"update_site" to "Standort aktualisieren",
"site_name" to "Standortname",
"site_name_mandatory" to "Standortname *",
"enter_site_name" to "Gib den Standortnamen ein",
"add_site" to "Standort hinzufügen",
"add_new_button" to "Neu\\nhinzufügen",
"add_note_here" to "Füge deine Notiz hier hinzu",
"enter_text" to "Text eingeben",
"add_your_note_here" to "Füge deine Notiz hier hinzu",
"note_added_successfully" to "Notiz erfolgreich hinzugefügt",
"note_updated_successfully" to "Notiz erfolgreich aktualisiert",
"note_deleted_successfully" to "Notiz wurde erfolgreich gelöscht",
"file_added" to "Datei wurde erfolgreich hinzugefügt",
"site_added" to "Standort erfolgreich hinzugefügt",
"site_updated" to "Standort erfolgreich aktualisiert",
"site_deleted" to "Standort erfolgreich gelöscht",
"job_updated" to "Job erfolgreich aktualisiert",
"job_added" to "Job erfolgreich hinzugefügt",
"job_finished" to "Job erfolgreich abgeschlossen",
"job_deleted" to "Job erfolgreich gelöscht",
"user_deleted" to "Benutzer erfolgreich gelöscht",
"contact_added" to "Kontakt erfolgreich hinzugefügt",
"contact_deleted" to "Kontakt erfolgreich gelöscht",
"report_submitted" to "Bericht erfolgreich eingereicht",
"job_rejected" to "Job-Bericht abgelehnt",
"login_to_access" to "Melde dich an, um auf deine Aufgaben und Verantwortlichkeiten zuzugreifen",
"password_set" to "Passwort erfolgreich gesetzt! Du kannst dich mit deinen Anmeldedaten anmelden.",
"try_another_document" to "Etwas ist schiefgelaufen, versuche ein anderes Dokument",
"confirm_password_reset" to "Wir haben einen Link zum Passwort zurücksetzen an deine E-Mail geschickt. Bitte schaue in deinem Postfach nach und klicke auf den Link, um dein Passwort zu ändern.",
"thank_you_for_registering" to "Danke für deine Anmeldung! Wir haben einen Bestätigungslink an deine E-Mail geschickt. Bitte schaue in deinem Postfach nach und klicke auf den Link, um deine Registrierung abzuschließen.",
"full_name_required" to "Vollständiger Name ist erforderlich.",
"phone_number_required" to "Telefonnummer ist erforderlich.",
"email_required" to "E-Mail ist erforderlich.",
"city_required" to "Stadt ist erforderlich.",
"country_required" to "Land ist erforderlich.",
"address_required" to "Adresse ist erforderlich.",
"zip_required" to "Postleitzahl ist erforderlich",
"status_required" to "Status ist erforderlich.",
"skill_required" to "Eine Fähigkeit muss ausgewählt werden.",
"team_required" to "Ein Team muss ausgewählt werden.",
"done_selecting_dates" to "Fertig",
"assigned_to" to "Zugewiesen an:",
"assignees" to "Zugewiesene",
"selected" to "ausgewählt",
"start_time" to "Startzeit",
"end_time" to "Endzeit",
"completed" to "abgeschlossen",
"minutes" to "Minuten",
"notes" to "Notizen",
"add_file" to "Datei hinzufügen",
"add_note" to "Notiz hinzufügen",
"document" to "Dokument",
"documents" to "Dokumente",
"images" to "Bilder",
"submit" to "Formular abschicken",
"map" to "Karte",
"notifications" to "Benachrichtigungen",
"from_phone" to "Von Dateien auswählen",
"choose_action" to "Wähle eine Aktion:",
"take_picture" to "Foto machen",
"remove_file" to "Datei entfernen",
"upload_signature" to "Ein Bild von der Unterschrift des Kunden hochladen",
"your_comment" to "Dein Kommentar",
"comment" to "Kommentar",
"additional_notes" to "Zusätzliche Notizen hinzufügen",
"safety_requirements" to "Sind alle Gesundheits- und Sicherheitsanforderungen erfüllt worden?",
"safety_requirements_title" to "Welche Sicherheitsanforderungen sind nicht erfüllt worden?",
"safety_requirements_desc" to "Nicht erfüllte Sicherheitsanforderungen",
"yes" to "Ja",
"no" to "Nein",
"enter_city" to "Stadt eingeben",
"enter_country" to "Land eingeben",
"enter_zip_code" to "PLZ eingeben",
"no_damage" to "Kein Schaden",
"all_contacts" to "Alle Kontakte",
"was_damage_caused" to "Ist während der Arbeit Schaden entstanden?",
"damage_title" to "Welcher Schaden ist entstanden?",
"damage_desc" to "Schaden beschreiben",
"final_inspection" to "Ist eine Schlussabnahme durchgeführt worden und bestätigt worden, dass alles richtig funktioniert?",
"final_inspection_fail" to "Warum ist die Abnahme nicht durchgeführt worden?",
"final_inspection_desc" to "Grund für unvollständige Inspektion",
"client_feedback" to "Kunden-Feedback",
"feedback" to "Feedback:",
"enter_feedback" to "Jedes Feedback vom Kunden eingeben",
"client_signature" to "Unterschrift des Kunden:",
"search_to_find" to "Suchen, um ein Team zu finden oder zu erstellen",
"add_new_job_message" to "Bevor du eine neue Arbeit hinzufügst, musst du zuerst mindestens einen Kontakt anlegen",
"add_new_user_message" to "Bevor du eine neue Arbeit hinzufügst, musst du zuerst mindestens einen Mitarbeiter anlegen",
"add_new_site_message" to "Bevor du eine neue Arbeit hinzufügst, musst du zuerst mindestens einen Standort für einen bestehenden Kontakt anlegen",
"adding_proof" to "Nachweis der fertigen Arbeit hinzufügen",
"status_check" to "Statuskontrolle",
"additional_notes_report" to "Zusätzliche Notizen",
"employee_comments" to "Mitarbeiter-Kommentar:",
"health_confirmation" to "Gesundheits- und Sicherheitsbestätigung",
"were_safety_met" to "Sind alle Gesundheits- und Sicherheitsanforderungen erfüllt worden?",
"no_completion_report" to "Noch kein Abschlussbericht",
"report_will_appear" to "Der Bericht wird angezeigt, sobald ein Auftrag als abgeschlossen markiert wird.",
"admin" to "Administrator",
"manager" to "Manager",
"managers" to "Manager",
"employee" to "Mitarbeiter",
"file_deleted" to "Datei erfolgreich gelöscht!",
"confirmation" to "Bestätigung",
"are_you_sure" to "Bist du sicher, dass du löschen willst?",
"are_you_sure_note" to "Bist du sicher, dass du die Notiz löschen willst?",
"add_more" to "Mehr hinzufügen",
"mark_step_completed" to "Aufgabe als erledigt markieren",
"mark_step_pending" to "Aufgabe wieder öffnen",
"complete_all_tasks_before_submitting_report" to "Bitte schließen Sie alle Aufgaben ab, bevor Sie den Bericht einreichen",
"you_chose" to "Du hast gewählt",
"change_plan" to "Plan ändern",
"current_plan" to "Aktueller Plan",
"manage_subscription" to "Verwalte dein Abonnement",
"change_or_upgrade_subscription" to "Du kannst dein Abonnement jederzeit ändern oder upgraden.",
"cancel_subscription" to "Abonnement kündigen",
"what_happens" to "Was passiert, wenn du kündigst?",
"you_will_lose" to "Du verlierst den Zugriff auf Premium-Funktionen nach dem Ende des aktuellen Abrechnungszyklus",
"your_data_will" to "Deine Daten bleiben gespeichert und du kannst jederzeit wieder abonnieren",
"team_members_linked" to "Teammitglieder, die mit dem Plan verbunden sind, können den Zugriff auf die App verlieren",
"before_you_proceed" to "Bevor du fortfährst, überlege dir",
"downgrading_to_lower" to "Abstufung auf einen günstigeren Plan, wenn der aktuelle deine Anforderungen nicht erfüllt",
"contacting_support_for_assistance" to "Kontaktiere den Support für Hilfe mit deinem Abonnement oder Konto",
"keep_my_subscription" to "Mein Abonnement behalten",
"continue_cancellation" to "Mit der Kündigung fortfahren",
"week" to "Woche",
"day" to "Tag",
"month_capitalized" to "Monat",
"contact_type_customer" to "Kunde",
"contact_type_supplier" to "Lieferant",
"contact_type_contractor" to "Unternehmer",
"job_schedule" to "Arbeitsplan",
"deadline_and_duration" to "Termin & Dauer",
"duration" to "Dauer",
"contact_and_site_details" to "Kontakt- und Standortdetails",
"newest" to "Neueste",
"oldest" to "Älteste",
"delete_job" to "Arbeit löschen",
"start_end_time" to "Die Endzeit muss später als die Startzeit sein. Bitte wähle eine gültige Zeit.",
"user_status_inactive" to "Inaktiv",
"user_status_active" to "Aktiv",
"user_status_pending" to "Warte auf Bestätigung",
"search_map" to "Suche nach Arbeit, Adresse...",
"not_scheduled" to "Nicht geplant",
"no_dates_selected" to "Keine Termine ausgewählt",
"not_assigned" to "Nicht zugewiesen",
"no_information" to "Keine Information",
"upload_photos_of_completed_job" to "Fotos der fertigen Arbeit hochladen",
"lets_get_to_work" to "Lass uns anfangen!",
"plan_active_until" to "* Ihr aktueller Plan ist aktiv bis ",
"error_manager_number" to "Bitte passen Sie die Anzahl der Manager in Ihrem Arbeitsbereich an, damit diese den Planlimits entspricht!",
"error_employee_number" to "Bitte passen Sie die Anzahl der Mitarbeitenden in Ihrem Arbeitsbereich an, damit diese den Planlimits entspricht!",
"nothing_to_cancel" to "Sie nutzen derzeit den kostenlosen Plan, daher gibt es nichts zu kündigen. Viel Spass beim Zugriff!",
"you_are_subscribed" to "Sie sind abonniert! Prüfen Sie Ihr Postfach für Updates.",
"no_plan_selected" to "Kein Plan ausgewählt",
"unknown_error" to "Ein unbekannter Fehler ist aufgetreten",
"resend_confirmation_link" to "Hier klicken, um den Bestätigungslink erneut zu senden",
"plan_downgrade_scheduled" to "Eine Planänderung ist geplant und beginnt mit dem Plan ",
"no_data_received" to "Keine Daten empfangen",
"unexpected_error" to "Ein unerwarteter Fehler ist aufgetreten",
"workspace_not_found" to "Arbeitsbereich nicht gefunden",
"contact_name_required" to "Kontaktname ist erforderlich.",
"site_name_required" to "Standortname ist erforderlich.",
"job_title_required" to "Berufsbezeichnung ist erforderlich.",
"role_required" to "Rolle ist erforderlich.",
"january" to "Januar",
"february" to "Februar",
"march" to "März",
"april" to "April",
"may" to "Mai",
"june" to "Juni",
"july" to "Juli",
"august" to "August",
"september" to "September",
"october" to "Oktober",
"november" to "November",
"december" to "Dezember",
"this_week" to "Diese Woche",
"members" to "Mitglieder",
"not_possible_to_buy_plan" to "Derzeit ist es nicht möglich, einen Plan zu kaufen.",
"unassigned" to "Nicht zugewiesen",
"unnamed_team" to "Unbenanntes Team",
"password_length" to "Das Passwort muss mindestens 8 Zeichen lang sein",
"you_are_offline" to "Du bist offline.\nBitte überprüfe deine Internetverbindung. Einige Funktionen sind möglicherweise nicht verfügbar, bis du wieder online bist.",
"no_matching_skills" to "Keine passenden Fähigkeiten. Tippe auf '+', um hinzuzufügen.",
"no_skills_available" to "Keine Fähigkeiten verfügbar. Gib einen Namen ein, um eine neue zu erstellen.",
"no_matching_teams" to "Keine passenden Teams. Tippe auf '+', um hinzuzufügen.",
"no_teams_available" to "Keine Teams verfügbar. Gib einen Namen ein, um ein neues zu erstellen.",
"no_matching_industries" to "Keine passenden Branchen. Tippe auf „+“, um eine hinzuzufügen.",
"no_industries_available" to "Keine Branchen verfügbar. Gib einen Namen ein, um eine neue zu erstellen.",
"passwords_do_not_match" to "Passwörter stimmen nicht überein",
"email_format_not_valid" to "Gib eine gültige E-Mail-Adresse ein",
"files_skipped_title" to "Einige Dateien wurden nicht hochgeladen",
"files_skipped_message" to "Dateien, die größer als 10 MB sind, können nicht hochgeladen werden.",
"job_start_time_error" to "Job-Startzeit ist erforderlich.",
"job_end_time_error" to "Job-Endzeit ist erforderlich.",
"task_title_error" to "Aufgabentitel ist erforderlich.",
"note_empty" to "Sie können hier Notizen hinzufügen, um wichtige Informationen zu diesem Prozess festzuhalten. Klicken Sie auf die Schaltfläche „Notiz hinzufügen“, um einen neuen Eintrag zu erstellen. Alle hinzugefügten Notizen werden hier angezeigt.",
"file_empty" to "Sie können Dateien in verschiedenen Formaten hochladen, darunter .png, .pdf und andere. Klicken Sie einfach auf die Schaltfläche „Datei hinzufügen“, um den Upload zu starten. Nach dem Hochladen werden die Dateien hier angezeigt.",
"task_empty" to "Sie können hier Aufgaben hinzufügen, um Maßnahmen zu diesem Prozess zu verfolgen. Klicken Sie auf die Schaltfläche „Aufgabe hinzufügen“, um einen neuen Eintrag zu erstellen. Alle hinzugefügten Aufgaben werden hier angezeigt.",
"filter_empty" to "Es gibt nichts zu filtern"
            )
        }